@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../../constants/spacing.module.less';

.product-list-container {
  margin-top: @space-8;
}

.product-list-header {
  margin-bottom: @space-8;
  width: 100%;
}

.clear-all-button {
  padding: @space-0;
  margin: @space-0;
  height: auto;
  color: var(--blue-600, #006fbb);
}

.clear-icon {
  width: 12px;
  margin-right: @space-8;
}

.product-table-container {
  border: 1px solid var(--grey-300);
}

.product-table {
  overflow-x: auto;
}

.header-row {
  min-width: fit-content !important;
}

.empty-row-text {
  padding: @space-40 @space-0;
  align-self: stretch;
  color: var(--grey-600);
  text-align: center;
}

.justify-center {
  justify-content: center;
  text-align: center;
  padding-right: @space-4;
}

.actions-input-container {
  justify-content: center;
  width: 100%;
}

.qty-cell {
  padding-right: @space-24;
  flex-wrap: nowrap;
}

.qty-button {
  padding: @space-4 @space-8;
  min-width: fit-content;
  height: 32px;
  white-space: nowrap;
}

.qty-error {
  color: var(--red-600);
  margin-top: @space-4;
}

.no-bottom-border {
  border-bottom: none;
}

.qty-input {
  width: 80px;
}

.qty-input-error input {
  border-color: var(--red-600);
}

.product-cell-with-collapse {
  align-items: flex-start;
  flex-wrap: nowrap;
}

.collapse-button-placeholder {
  width: 24px;
  min-width: 24px;
}

.product-column-header {
  padding-left: 28px;
}
